var loadmoreInit;

(function ($) {

	const selectors = {
		button: '[data-loadmore]',
	}

	loadmoreInit = function () {
		$(selectors.button).each((i, el) => {
			new LoadmoreButton(el);
		});
	}

	class LoadmoreButton {
		constructor(el) {

			this.$button = $(el);

			this.init();
			this.bind();

		}

		init() {

			const self = this;

			this.$postWrap = $(this.$button.attr('data-wrap'));

			this.template = this.$postWrap.attr('data-template');
			this.itemClass = this.$postWrap.children().first().attr('class');
			this.disp = this.$postWrap.children().first().css('display');
			this.query_args = this.$postWrap.attr('data-query-args') ? JSON.parse(this.$postWrap.attr('data-query-args')) : false;

			this.data = {
				'action': 'loadmore',
				'query_args': this.query_args,
				'page': this.$postWrap.attr('data-current-page') ? parseInt(this.$postWrap.attr('data-current-page')) : wp_params.current_page,
				'template': this.$postWrap.attr('data-template'),
				'wrapper': this.itemClass,
				'filters': []
			};

		}

		bind() {
			this.loadmore = this.loadmore.bind(this);
			this.$button.on('click', this.loadmore);
			this.$postWrap.on('reload', this.loadmore);
		}

		loadmore(e) {
			e.preventDefault();

			const self = this;

			var currentPage = parseInt(this.$postWrap.attr('data-current-page'));
			self.data.page = currentPage;
			self.data.filters = JSON.parse(self.$postWrap.attr('data-filters'));

			$.ajax({
				url: wp_params.ajax_url, // AJAX handler
				data: self.data,
				type: 'POST',
				beforeSend: function () {
					self.$button.addClass('is-loading');
				},
				success: function (data) {

					console.log(data);

					if (currentPage == 0) {
						self.$postWrap.html(''); // do a reload
						if (!data.no_more_posts)
							self.$button.removeClass('fading no-posts').fadeIn(400);
					}

					if (!data || data.html === undefined) return;

					self.$postWrap.append(data.html);
					self.$postWrap.find('.ajax-loaded').css({ display: self.disp }).hide();
					self.$postWrap.find('.ajax-loaded').fadeIn(400).removeClass('ajax-loaded');

					self.$button.find('.loading').fadeOut();
					self.$button.removeClass('is-loading');

					self.$postWrap.attr('data-current-page', currentPage + 1);

					if (data.no_more_posts) {
						self.$button.addClass('fading').fadeOut(400);
						self.$button.removeClass('is-loading').addClass('no-posts');
					}

					$(document.body).trigger('post-load');

				}
			});

		}

	}

})(jQuery);

export default loadmoreInit;